<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorAlert',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
})
</script>

<template>
  <div class="payment-errors error-message">
    <img src="@/assets/icons/exclamation_mark.svg">
    {{ message }}
  </div>
</template>

<style scoped></style>
